import sentry from '@willing-shared/utils/sentry';

export function debugLog(message, notifySentry = true) {
  if (notifySentry) {
    sentry.message(message);
  }
}
